var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.dev/svgjs",
    width: "100%",
    preserveAspectRation: "none",
    opacity: 0.6,
    style: {
      backgroundColor: "black"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bbblurry-filter",
    x: "-100%",
    y: "-100%",
    width: "400%",
    height: "400%",
    filterUnits: "objectBoundingBox",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    in: "SourceGraphic",
    edgeMode: "none",
    result: "blur"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bbblurry-filter)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 400,
    ry: 400,
    cx: 300,
    cy: 120,
    fill: "hsla(225, 80%, 60%, 1.00)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 400,
    ry: 400,
    cx: 1050,
    cy: 500,
    fill: "hsl(185, 100%, 57%)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgBackground);
export default __webpack_public_path__ + "static/media/SvgBackground.7617fb9a69f0fcfec8782bd6ee08380a.svg";
export { ForwardRef as ReactComponent };